import type React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PAGE_NAME, UserModelData } from "../../types";
import ArthereumIcon from "../../WebAppsSharedStuffs/components/ArtheumIcon";

/** Desktop top bar: balances and the profile shortcut. */
const DesktopHeader: React.FC = () => {
  const navigate = useNavigate();
  const userData: UserModelData = useSelector(
    (state) => (state as any)?.actualUser
  );
  const user = userData?.user;

  return (
    <header className="fixed top-0 left-60 right-0 z-40 border-b border-gray-200 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="w-full flex h-16 items-center px-6 max-w-[1600px] mx-auto gap-4 justify-end">
        <button
          onClick={() => navigate(PAGE_NAME.SHOP)}
          className="flex items-center gap-2 bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg px-3 py-2 border border-amber-200/50 shadow-sm hover:shadow-md transition-all"
        >
          <ArthereumIcon size="w-4 h-4" />
          <span className="font-semibold text-amber-900 text-sm">
            {(user?.arthereumBalance ?? 0).toFixed(2)} ATH
          </span>
          <span className="text-amber-700/70 text-xs">·</span>
          <span className="font-semibold text-amber-900 text-sm">
            {(user?.picoinBalance ?? 0).toFixed(2)} π
          </span>
        </button>

        <button
          onClick={() => navigate(PAGE_NAME.PROFILE)}
          className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-100 transition-colors"
          title="Profile"
        >
          <div className="relative flex h-9 w-9 shrink-0 overflow-hidden rounded-full border border-gray-200">
            {user?.profileImage ? (
              <img className="aspect-square h-full w-full object-cover" src={user.profileImage} alt={user.username ?? "User"} />
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-blue-100 to-blue-200 text-blue-700 text-sm font-semibold">
                {(user?.username ?? "?").slice(0, 2).toUpperCase()}
              </div>
            )}
          </div>
          <span className="text-sm font-medium text-gray-800">@{user?.username}</span>
        </button>
      </div>
    </header>
  );
};

export default DesktopHeader;
